import React, { Component, Fragment } from 'react';
import Logs from '../../../AccountDetails/Panels/LeftPanel/Tabs/OrdersAndQuotes/Orders/Logs';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import { groupStyles } from '../../../../utils/SelectStyles';
import { isEmpty } from '../../../../utils/helpers';
import TargetDateTime from "../../../../components/UI/TargetDateTime";


class PersonalTableRow extends Component {
	state = {
		showLogs: false,
	};


	handleShowHideLogs = () => {
		this.setState((prevState) => ({
			showLogs: !prevState.showLogs
		}));
	};

	priorityColor = (priority) => {
		switch (priority) {
			case 'HIGH ':
				return 'badge badge-danger';
			case 'MEDIUM':
				return 'badge badge-info';
			case 'LOW ':
			case 'NEW':
				return 'badge badge-success';
			default:
				return '';
		}
	};


	render() {

		const {
			rowClass,
			tableHeadings,
			taskInfo,
			order,
			systemUsersData,
			handleShowHideDropdown,
			showTaskDropDownById,
			handleAssignTaskToUsername,
			showOrderDetails,
			accountId,
			renderTaskDetails,
			usernameOptions
		} = this.props;


		let transformedValue;

		if (systemUsersData.length > 0) {
			transformedValue = systemUsersData.map((systemUser) => {
				return {
					value: systemUser.username,
					label: systemUser.firstName + ' ' + systemUser.lastName
				};
			});
		}

		if (isEmpty(taskInfo)) {
			return null;
		}

		const hasAppointmentDetails = taskInfo.appointmentDetails && taskInfo.appointmentDetails.apptDate && taskInfo.appointmentDetails.apptTimeSlotFrom && taskInfo.appointmentDetails.apptTimeSlotTo;

		return (

			<Fragment>
				<tr className={rowClass}>
					<td className="" data-heading={tableHeadings[0]}>

						{taskInfo.name}

						{/* Show order details only if we're not in Account Details Orders / Tickets */}
						{showOrderDetails !== false &&
						<span className="td-subtitle">

							{taskInfo.endDateTime == null
								? <> Task: {taskInfo.id} | Created: {moment(taskInfo.createdDateTime).format('MM/DD/YYYY')} </>
								: <> Task: {taskInfo.id} | Completed: {moment(taskInfo.endDateTime).format('MM/DD/YYYY')} </>
							}

							{taskInfo.serviceOrderInfo && taskInfo.serviceOrderInfo.orderId && <>
								<br/>
								Order:&nbsp;{taskInfo.serviceOrderInfo.orderId}
							</> }

						</span>
						}

					</td>

					{/* Show Details Column only if we're not in Account Details Orders / Tickets */}
					{showOrderDetails !== false &&
					<td className="" data-heading={tableHeadings[1]}>

						{taskInfo && taskInfo.serviceOrderInfo && taskInfo.serviceOrderInfo.description}

						{taskInfo && taskInfo.troubleTicketDetails && taskInfo.troubleTicketDetails.reportedCode}

						<span className="td-subtitle">
							{taskInfo.serviceOrderInfo && taskInfo.serviceOrderInfo.serviceOrderId && (
								'SO: ' + taskInfo.serviceOrderInfo.serviceOrderId + ' | '
							)}
							{taskInfo.troubleTicketDetails && taskInfo.troubleTicketDetails.id && (
								'TT: ' + taskInfo.troubleTicketDetails.id + ' | '
							)}
							Created: {moment(taskInfo.serviceOrderInfo && taskInfo.serviceOrderInfo.createdDateTime).format('MM/DD/YYYY')}
							<br/>
							{taskInfo.customerName && (
								taskInfo.customerName
							)}
							<br/>
							{taskInfo.address1 && (
								taskInfo.address1
							)}

						</span>

						{taskInfo && taskInfo.serviceOrderInfo && taskInfo.serviceOrderInfo.targetDateTime &&
						<span className="td-subtitle">
							<TargetDateTime targetDateTime={taskInfo.serviceOrderInfo.targetDateTime} />
						</span>
						}

					</td>
					}

					<td className="" data-heading={tableHeadings[2]}>
						{taskInfo.endDateTime != null
						?
							<span className='badge-inline badge badge-success'>Done</span>
						:
							<>
							<span className={this.priorityColor(taskInfo.priority)}>{taskInfo.priority}</span>
							<span className="td-subtitle">
								{!hasAppointmentDetails && taskInfo.serviceOrderInfo && taskInfo.serviceOrderInfo.serviceOrderId && (
									taskInfo.dueDate ? `Due: ${moment(taskInfo.dueDate).format('MM/DD/YYYY')}` : 'No due date'
								)}
								{!hasAppointmentDetails && taskInfo.troubleTicketDetails && taskInfo.troubleTicketDetails.id && (
									taskInfo.troubleTicketDetails.troubleDueDate ? `Due: ${moment(taskInfo.troubleTicketDetails.troubleDueDate).format('MM/DD/YYYY')}` : 'No due date'
								)}
								{hasAppointmentDetails && <>
									<i className="fas fa-clock"/>
									{moment(taskInfo.appointmentDetails.apptDate).format('MM/DD/YYYY')}
									{' '}
									{moment(taskInfo.appointmentDetails.apptTimeSlotFrom).format('h:mm A')}
									{' - '}
									{moment(taskInfo.appointmentDetails.apptTimeSlotTo).format('h:mm A')}
								</>}
							</span>
							</>
						}
					</td>

					<td className="" data-heading={tableHeadings[3]}>

						{taskInfo.assignee ? taskInfo.assignee : <br />}
						{taskInfo.candidateUserGroups && (
							<span className="td-subtitle">
								{taskInfo.candidateUserGroups.map((candidate, index, arr) => {
									if (index !== arr.length - 1) {
										return `${candidate}; `;
									} else {
										return candidate;
									}
								})}
							</span>
						)}

					</td>

					<td className="" data-heading={tableHeadings[4]}>

						{(taskInfo.endDateTime != null && taskInfo.endDateTime !== "") ? "" :

						<div className="tr-actions">

							<div className={showTaskDropDownById === taskInfo.id ? 'dropdown show' : 'dropdown'}>
								<button
									className="btn btn-lg dropdown-toggle"
									type="button"
									id="dropdownMenuButton"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded={showTaskDropDownById === taskInfo.id}
									onClick={() => handleShowHideDropdown(taskInfo.id)}
								>
									<i className="fas fa-user-plus"/>
								</button>
								<div
									className={
										showTaskDropDownById === taskInfo.id ? (
											'dropdown-menu dropdown-menu-with-select dropdown-menu-right show'
										) : (
											'dropdown-menu dropdown-menu-with-select dropdown-menu-right'
										)
									}
									aria-labelledby="dropdownMenuButton"
								>
									<button
										onClick={() => handleAssignTaskToUsername('claim', taskInfo.id)}
										className="dropdown-item"
									>
										Claim
									</button>
									<button
										onClick={() => handleAssignTaskToUsername('unassign', taskInfo.id)}
										className="dropdown-item"
									>
										Unassign
									</button>
									<div className="dropdown-divider"/>
									<h6 className="dropdown-header">Assign To User</h6>
									<div className="dropdown-item">

										<Select
											// value={selectedEntities}
											onChange={(value) =>
												handleAssignTaskToUsername('username', taskInfo.id, value)}
											options={usernameOptions}
											styles={groupStyles}
											placeholder="Select"
										/>
									</div>

								</div>
							</div>


							{this.props.handleShowTaskDetails
							&&
							<div className="btn btn-lg"
								 style={this.props.taskIdSelected === taskInfo.id ? {color:'#1b8580'} : null}
								 onClick={() => {renderTaskDetails(taskInfo.id)}
							}>
								<i className="fas fa-fw fa-chevron-circle-right"/>
							</div>

							}

						</div>

						}

					</td>

				</tr>

				{this.state.showLogs && <Logs serviceOrderId={taskInfo.serviceOrderInfo.serviceOrderId} />}


			</Fragment>
		);
	}
}

PersonalTableRow.propTypes = {
	tableHeadings: PropTypes.array.isRequired,
	taskInfo: PropTypes.object.isRequired,
	handleShowHideDropdown: PropTypes.func,
	showTaskDropDownById: PropTypes.string
};


export default PersonalTableRow;

